import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateLocationOverrideRule } from '../../../api/plan-location-override-rules-api'
import type {
  PlanLocationOverrideRuleResponseDto,
  UpdatePlanLocationOverrideRuleRequestDto,
} from '../../../api/dto/plan-location-override-rules.dto'
import { LOCATION_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanLocationOverride/hooks/useGetLocationOverrideRules'
import { LOCATION_OVERRIDE_RULE_QUERY_KEY } from './useGetLocationOverrideRule'

export function useUpdateLocationOverrideRule(ruleId: string) {
  const queryClient = useQueryClient()

  return useMutation<
    PlanLocationOverrideRuleResponseDto,
    unknown,
    UpdatePlanLocationOverrideRuleRequestDto
  >({
    mutationFn: (body) => updateLocationOverrideRule(ruleId, body),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [LOCATION_OVERRIDE_RULE_QUERY_KEY, ruleId],
      })
    },
  })
}
